import React from "react";
import * as Icon from 'react-feather';
import ScrollUp from "react-scroll-up";

const ScrollToTop = (props) => (
    <div className="scroll-top-top">
        <ScrollUp showUnder={160}>
            <span><Icon.ArrowUpCircle size={48}/></span>
        </ScrollUp>
    </div>
)

export default ScrollToTop;


// WEBPACK FOOTER //
// ./src/scrollToTop.js